import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles.css'
import './config.js'
import { reportError } from './errors.jsx'
import { ErrorBar } from './errors.jsx'
import App from './app.jsx'

// Global error handlers
window.addEventListener("error", function (e) {
  reportError({
    code: "WYF-NET-002",
    where: "Global / " + (e.filename || "unknown"),
    message: e.message || "Uncaught error",
    detail: (e.error && e.error.stack) || ""
  });
});

window.addEventListener("unhandledrejection", function (e) {
  var reason = e.reason;
  if (!reason) return;
  if (reason.name === "AbortError" || (reason.message || "").toLowerCase().includes("aborted") ||
      (reason.message || "").toLowerCase().includes("signal")) return;
  reportError({
    code: "WYF-NET-002",
    where: "Promise rejection",
    message: (reason.message) || "Unhandled promise rejection",
    detail: (reason.stack) || String(reason)
  });
});

// Init theme before React mounts
const t = localStorage.getItem("wyf-theme") || "dark";
document.documentElement.dataset.theme = t;

function Root() {
  return (
    <>
      <App />
      <ErrorBar />
    </>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
